import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthBagService } from '../auth-bag.service';
import { AuthService } from '../auth.service';

@Component({
	selector: 'app-logout',
	templateUrl: './logout.component.html',
})
export class LogoutComponent implements OnInit {
	constructor(
		private readonly auth: AuthService,
		private readonly authBag: AuthBagService,
		private readonly router: Router,
	) {}

	ngOnInit(): void {
		this.auth.unauth();
		this.authBag.unauth();
		this.router.navigate(['']);
	}
}
